import { Card, Col, Container, Row } from "react-bootstrap";
import {
    DashboardMetric,
    FinalQaList,
    InitialQaList,
    MockAuditForms,
    MockEventReportForms,
    MockLabForms,
    MockValidationForms,
    QaAuditForms,
    QaEventReportForms,
    QaLabForms,
    QaValidationForms,
} from "../..";
import { useState } from "react";
import { fas, Icon, LoadingSpinner } from "../../../../component-library";
import { useDonorQuery } from "../../../../queries";
import { Link, useNavigate } from "react-router-dom";

enum QaMetrics {
    InitialQA = "Initial QA",
    FinalQA = "Final QA",
    Autopsy = "Autopsy",
    ChartAudit = "Chart Audit",
    FlaggedForms = "Flagged Forms",
    Audits = "Audits",
    Validations = "Validations",
    EventReports = "Event Reports",
    LabForms = "Lab Forms",
}

export function QualityAssuranceDashboard() {
    const navigate = useNavigate();
    const {
        qaDashboardQuery: { data, isFetching },
    } = useDonorQuery({ queryType: "qa-dashboard" });
    const [selectedMetric, setSelectedMetric] = useState<string>("");

    if (isFetching) return <LoadingSpinner />;

    return (
        <Container>
            <div className="d-flex justify-content-between align-items-center">
                <h1>Quality Assurance Dashboard</h1>
                <Link to={"/chart-review-logs"}>View Chart Audit History</Link>
                {/* Future date filter for general QA */}
                {/* <div>
                    2023-06-01 to present{" "}
                    <Icon icon={fas.faPenToSquare} className="text-primary clickable" tabIndex={0} />
                </div> */}
            </div>

            <Row className="gx-3">
                <Col className="mb-3">
                    <Card className="bg-primary text-white">
                        <Card.Header>Donor QA</Card.Header>
                        <Card.Body className="bg-white">
                            <Row>
                                {data?.caseMetrics?.map((metric) => (
                                    <Col key={metric.status}>
                                        <DashboardMetric
                                            title={metric.status}
                                            value={metric.count}
                                            onClick={() => navigate(`/lists/${metric.listSlug}/cases`)}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>

                {/* <Col className="mb-3" lg={8}>
                    <Card className="bg-primary text-white">
                        <Card.Header>
                            General QA{" "}
                            <Icon
                                icon={fas.faInfoCircle}
                                title="Metrics for active (unsigned) forms"
                                aria-label="Metrics for active (unsigned) forms"
                                //className="text-"
                            />
                        </Card.Header>
                        <Card.Body className="bg-white">
                            <Row>
                                <Col xs={12} sm={3}>
                                    <DashboardMetric
                                        title={QaMetrics.Audits}
                                        value={MockAuditForms.filter((f) => !f.signedOn).length}
                                        onClick={() => setSelectedMetric(QaMetrics.Audits)}
                                        isActive={selectedMetric === QaMetrics.Audits}
                                        footer={<span>{MockAuditForms.filter((f) => !!f.signedOn).length} Signed</span>}
                                    />
                                </Col>
                                <Col xs={12} sm={3}>
                                    <DashboardMetric
                                        title={QaMetrics.Validations}
                                        value={MockValidationForms.filter((f) => !f.signedOn).length}
                                        onClick={() => setSelectedMetric(QaMetrics.Validations)}
                                        isActive={selectedMetric === QaMetrics.Validations}
                                        footer={
                                            <span>{MockValidationForms.filter((f) => !!f.signedOn).length} Signed</span>
                                        }
                                    />
                                </Col>
                                <Col xs={12} sm={3}>
                                    <DashboardMetric
                                        title={QaMetrics.EventReports}
                                        value={MockEventReportForms.filter((f) => !f.signedOn).length}
                                        onClick={() => setSelectedMetric(QaMetrics.EventReports)}
                                        isActive={selectedMetric === QaMetrics.EventReports}
                                        footer={
                                            <span>
                                                {MockEventReportForms.filter((f) => !!f.signedOn).length} Signed
                                            </span>
                                        }
                                    />
                                </Col>
                                <Col xs={12} sm={3}>
                                    <DashboardMetric
                                        title={QaMetrics.LabForms}
                                        value={MockLabForms.filter((f) => !f.signedOn).length}
                                        onClick={() => setSelectedMetric(QaMetrics.LabForms)}
                                        isActive={selectedMetric === QaMetrics.LabForms}
                                        footer={<span>{MockLabForms.filter((f) => !!f.signedOn).length} Signed</span>}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col> */}
            </Row>

            {/* {selectedMetric === QaMetrics.InitialQA && <InitialQaList />}
            {selectedMetric === QaMetrics.FinalQA && <FinalQaList />}
            {selectedMetric === QaMetrics.Audits && <QaAuditForms />}
            {selectedMetric === QaMetrics.Validations && <QaValidationForms />}
            {selectedMetric === QaMetrics.EventReports && <QaEventReportForms />}
            {selectedMetric === QaMetrics.LabForms && <QaLabForms />} */}
        </Container>
    );
}
